import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Menu } from "lucide-react";
import DocsSidebar from "./DocsSidebar";
import DocsSearch from "./DocsSearch";
import DocsIndex from "./DocsIndex";
import DocsPage from "./DocsPage";

const SIDEBAR_WIDTH = 250;

export default function DocsLayout() {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Cmd+K / Ctrl+K keyboard shortcut
  useEffect(() => {
    function handleKeyDown(e) {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        setSearchOpen((v) => !v);
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div
      className="min-h-screen font-['DM_Sans']"
      style={{ background: "#FAFAF8" }}
    >
      {/* Sidebar */}
      <DocsSidebar
        onSearchClick={() => setSearchOpen(true)}
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />

      {/* Mobile top bar */}
      <header
        className="flex md:hidden items-center justify-between px-4 py-3 fixed top-0 left-0 right-0 z-20"
        style={{
          background: "#0A1628",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <button
          onClick={() => setMobileMenuOpen(true)}
          className="text-white/70 hover:text-white transition-colors p-1"
        >
          <Menu size={20} />
        </button>
        <span
          className="font-['Syne'] font-bold text-white"
          style={{ fontSize: 15 }}
        >
          Acadence{" "}
          <span
            className="font-['DM_Sans'] font-normal rounded px-1"
            style={{
              fontSize: 11,
              background: "rgba(75,123,245,0.2)",
              color: "#4B7BF5",
            }}
          >
            docs
          </span>
        </span>
        <button
          onClick={() => setSearchOpen(true)}
          className="text-white/70 hover:text-white transition-colors p-1"
        >
          {/* search icon inline to avoid extra import */}
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
        </button>
      </header>

      {/* Main content */}
      <main
        className="md:pl-0 pt-14 md:pt-0"
        style={{ marginLeft: 0 }}
      >
        <div
          className="hidden md:block"
          style={{ marginLeft: SIDEBAR_WIDTH }}
        >
          {/* content wrapper for desktop */}
        </div>
        <div
          className="md:ml-[250px]"
          style={{ minHeight: "100vh" }}
        >
          <Routes>
            <Route index element={<DocsIndex />} />
            <Route path=":section/:slug" element={<DocsPage />} />
          </Routes>
        </div>
      </main>

      {/* Search modal */}
      {searchOpen && (
        <DocsSearch
          onClose={() => setSearchOpen(false)}
        />
      )}
    </div>
  );
}
